export default __webpack_public_path__ + "static/media/superficial_peels.08c359b9.pdf";